/******************************************************************************
 *** MbrasDepartApply ** 소속변경 신청서
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

import MemberFile from "../FileBox/MemberFile";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";

const MbrasDepartApply = (props: any) => {
    const {
        mbrasId,
        mbrasAtrzDocId,
        selectedMember,
        setModalOpen,
        setModalStep,
        setCallTime,
    } = props;

    const [mbrasNm      , setMbrasNm      ] = React.useState(""); // 성명
    const [telno        , setTelno        ] = React.useState(""); // 전화번호
    const [brdtDate     , setBrdtDate     ] = React.useState(""); // 생년월일
    const [gndrCd       , setGndrCd       ] = React.useState(""); // 성별
    const [frstJncmpYmd  , setFrstJncmpYmd  ] = React.useState(""); // 입직년월일
    const [mbrasJoinSttsCd, setMbrasJoinSttsCd] = React.useState(""); // 조합원 가입상태
    const [wthdStatusCd , setWthdStatusCd ] = React.useState(""); // 원천징수 상태

    const [upOgnzCd     , setUpOgnzCd     ] = React.useState(""); // 현재 본부
    const [ogdpOrgCd    , setOgdpOrgCd    ] = React.useState(""); // 현재 지부
    const [wtjrNm       , setWtjrNm       ] = React.useState(""); // 현재 관내
    const [lbrShpSeCd   , setLbrShpSeCd   ] = React.useState(""); // 현재 근로형태
    const [ocptTypeCd   , setOcptTypeCd   ] = React.useState(""); // 현재 직종
    const [addr         , setAddr         ] = React.useState(""); // 현재 주소

    const [chgUpOgnzCd  , setChgUpOgnzCd  ] = React.useState(""); // 변경 본부
    const [chgOgdpOrgCd , setChgOgdpOrgCd ] = React.useState(""); // 변경 지부
    const [chgWtjrNm    , setChgWtjrNm    ] = React.useState(""); // 변경 관내
    const [chgOcptTypeCd, setChgOcptTypeCd] = React.useState(""); // 변경 직종
    const [chgAddr      , setChgAddr      ] = React.useState(""); // 변경 주소

    const [applyDt      , setApplyDt      ] = React.useState("");   // 발령일자
    const [atrzSttsCd   , setAtrzSttsCd   ] = React.useState("01"); // 결재상태
    const [atrzOpnnCn   , setAtrzOpnnCn   ] = React.useState("");   // 반려사유
    const [listLine     , setListLine     ] = React.useState<any[]>([]); // 결재 라인 정보
    const [openLine     , setOpenLine     ] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [etcFile      , setEtcFile      ] = React.useState<File>(); // 기타 첨부파일
    const [etcFileNm    , setEtcFileNm    ] = React.useState("");     // 기타 첨부파일명
    const [etcAtchFileId, setEtcAtchFileId] = React.useState("");     // 기타 첨부파일 ID

    // 현재 조합원 정보
    React.useEffect(() => {
        if (!selectedMember) return;

        setMbrasNm    (String(selectedMember.mbrasNm));     // 성명
        setTelno      (String(selectedMember.telno));       // 전화번호
        setBrdtDate   (String(selectedMember.brdtDate));    // 생년월일
        setGndrCd     (String(selectedMember.gndrCd));      // 성별
        setFrstJncmpYmd(String(selectedMember.frstJncmpYmd)); // 입직년월일
        setMbrasJoinSttsCd(String(selectedMember.mbrasJoinSttsCd)); // 조합원 가입상태
        setWthdStatusCd(String(selectedMember.wthdStatusCd));       // 원천징수 상태
        setUpOgnzCd   (String(selectedMember.upOgnzCd));    // 현재 본부
        setOgdpOrgCd  (String(selectedMember.ogdpOrgCd));   // 현재 지부
        setWtjrNm     (String(selectedMember.wtjrNm));      // 현재 관내
        setLbrShpSeCd (String(selectedMember.lbrShpSeCd));  // 현재 근로형태
        setOcptTypeCd (String(selectedMember.ocptTypeCd));  // 현재 직종
        setAddr       (String(selectedMember.addr));        // 현재 주소
        if (Util.isEmpty(mbrasAtrzDocId)) {
            setChgUpOgnzCd  (String(selectedMember.upOgnzCd));   // 변경 본부 기본값
            setChgOgdpOrgCd (String(selectedMember.ogdpOrgCd));  // 변경 지부 기본값
            setChgWtjrNm    (String(selectedMember.wtjrNm));     // 변경 관내 기본값
            setChgOcptTypeCd(String(selectedMember.ocptTypeCd)); // 변경 직종 기본값
            setChgAddr      (String(selectedMember.addr));       // 변경 주소 기본값
        }
    }, [selectedMember, mbrasAtrzDocId]);

    // 기존 변경 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId, // 조합원 결재 문서 ID
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc; // 변경 결재 문서정보
                const listItem = res.result.listItem; // 변경 신청 내역
                const listFile = res.result.listFile; // 첨부파일 목록
                const atrzLine = res.result.listLine; // 결재라인

                const upOgnzItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "03"); // 본부 변경정보
                const ogdpOrgItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "04"); // 지부 변경정보
                const ocptTypeItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "02"); // 직종 변경정보
                const wtjrItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "05"); // 관내 변경정보
                const addrItem     = listItem.find((item: any) => item.mbrasInfoChgSeCd === "06"); // 주소 변경정보

                if (upOgnzItem)   setChgUpOgnzCd  (String(upOgnzItem.chgAfterCn));   // 변경 본부
                if (ogdpOrgItem)  setChgOgdpOrgCd (String(ogdpOrgItem.chgAfterCn)); // 변경 지부
                if (ocptTypeItem) setChgOcptTypeCd(String(ocptTypeItem.chgAfterCn)); // 변경 직종
                if (wtjrItem)     setChgWtjrNm    (String(wtjrItem.chgAfterCn));     // 변경 관내
                if (addrItem)     setChgAddr      (String(addrItem.chgAfterCn));     // 변경 주소

                setApplyDt    (String(mbrasDoc.applyDt));     // 발령일자
                setAtrzSttsCd (String(mbrasDoc.atrzSttsCd));  // 결재상태
                setAtrzOpnnCn (String(mbrasDoc.atrzOpnnCn));  // 반려사유
                setListLine   (atrzLine);                     // 결재라인

                const etcFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                if (etcFileInfo) {
                    setEtcAtchFileId(String(etcFileInfo.mbrasAtchFileId)); // 기타 첨부파일 ID
                    setEtcFileNm    (String(etcFileInfo.fileNm));          // 기타 첨부파일명
                }

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId]);

    const getParamData = (saveAtrzSttsCd: string) => {
        return {
            mbrasAtrzDocId: mbrasAtrzDocId, // 조합원 결재 문서 ID
            mbrasAtrzSeCd : "05",            // 소속변경
            mbrasId       : mbrasId,         // 조합원 ID
            mbrasJoinSttsCd: mbrasJoinSttsCd, // 조합원 가입상태
            wthdStatusCd  : wthdStatusCd,     // 원천징수 상태

            mbrasNm       : mbrasNm,         // 성명
            telno         : telno,           // 전화번호
            brdtDate      : brdtDate,        // 생년월일
            gndrCd        : gndrCd,          // 성별
            frstJncmpYmd  : frstJncmpYmd,    // 입직년월일

            upOgnzCd      : upOgnzCd,        // 현재 본부
            ogdpOrgCd     : ogdpOrgCd,       // 현재 지부
            wtjrNm        : wtjrNm,          // 현재 관내
            lbrShpSeCd    : lbrShpSeCd,      // 현재 근로형태
            ocptTypeCd    : ocptTypeCd,      // 현재 직종
            addr          : addr,            // 현재 주소

            chgUpOgnzCd   : chgUpOgnzCd,     // 변경 본부
            chgOgdpOrgCd  : chgOgdpOrgCd,    // 변경 지부
            chgWtjrNm     : chgWtjrNm,       // 변경 관내
            chgLbrShpSeCd : lbrShpSeCd,      // 변경 근로형태(현재값 고정)
            chgOcptTypeCd : chgOcptTypeCd,   // 변경 직종
            chgAddr       : chgAddr,         // 변경 주소

            applyDt       : applyDt,         // 발령일자
            atrzSttsCd    : saveAtrzSttsCd,  // 01: 임시저장, 02: 작성완료
            etcFile       : etcFile,         // 기타 첨부파일
            callType      : "MEMBER",        // 첨부파일 저장경로
        };
    };

    const handleSave = (saveAtrzSttsCd: string) => {
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgUpOgnzCd)) { AppContext.openAlert({ title: "본부 확인", msg: "변경할 본부를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isNotEmpty(chgUpOgnzCd) && Util.isEmpty(chgOgdpOrgCd)) { AppContext.openAlert({ title: "소속지부 확인", msg: "변경할 소속지부를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && ogdpOrgCd === chgOgdpOrgCd) { AppContext.openAlert({ title: "소속 확인", msg: "현재 소속과 변경할 소속이 동일합니다.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(applyDt)) { AppContext.openAlert({ title: "발령일자 확인", msg: "발령일자를 입력해주세요.", icon: "warning" }); return; }

        const saveTitle = saveAtrzSttsCd === "01" ? "임시저장" : "작성완료";
        const saveMsg = saveAtrzSttsCd === "01" ? "임시 저장하시겠습니까?" : "작성완료 처리하시겠습니까?";

        AppContext.openAlert({
            title      : saveTitle,
            msg        : saveMsg,
            confirmText: saveTitle,
            handleConfirm: () => {
                const paramData = getParamData(saveAtrzSttsCd);

                AppContext.showSpinner();

                Axios.dataAccess({
                    url        : "system/mbras/chg/save-mbras-atrz-chg.do",
                    methodType : "post",
                    isMultipart: true,
                    paramData  : paramData,
                    onSuccessFn: () => {
                        setAtrzSttsCd(saveAtrzSttsCd);

                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "저장 완료",
                            msg  : saveAtrzSttsCd === "01" ? "임시저장 처리되었습니다." : "작성완료 처리되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    const handleDelete = () => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.openAlert({
            title      : "삭제",
            msg        : "정말 삭제하시겠습니까?",
            confirmText: "삭제하기",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url       : "system/mbras/chg/delete-mbras-atrz-chg.do",
                    methodType: "post",
                    paramType : "json",
                    paramData : {
                        mbrasAtrzDocId: mbrasAtrzDocId,
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "삭제 완료",
                            msg  : "삭제가 완료되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    const getChangeStatus = (nowValue: any, chgValue: any) => {
        const now = String(nowValue ?? "").trim();
        const chg = String(chgValue ?? "").trim();

        if (now === chg) return "KEEP";                                  // 유지
        if (Util.isNotEmpty(now) && Util.isEmpty(chg)) return "DELETE";  // 삭제

        return "CHANGE";                                                  // 변경
    };

    const renderChangeStatus = (nowValue: any, chgValue: any) => {
        const status = getChangeStatus(nowValue, chgValue);

        const text      = status === "CHANGE" ? "변경"   : status === "DELETE" ? "삭제"   : "유지";
        const className = status === "KEEP"   ? "fm-b fs12 fc666666" : "fm-b fs12 fcWhite";
        const bgColor   = status === "CHANGE" ? "#E53935" : status === "DELETE" ? "#555555" : "#F6F6F6";

        return <span className={className} style={{ backgroundColor: bgColor, padding: "4px 7px", borderRadius: "12px" }}>{text}</span>;
    };

    return (
        <div className="w100p dpFlx">
            <div className="w540">
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                            showOrgInfo={true}
                        />
                    </div>
                )}

                {/* 조합원 정보 */}
                <div className="m10">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">조합원 정보</div>

                    <div className="p14 bd1 bdcDDDDDD bdrd10 bgcFAFAFA bsBdb">
                        <div className="dpFlx flxNowrap jcSb">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성명</span>
                                <TextBox
                                    value={mbrasNm}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">전화번호</span>
                                <TextBox
                                    value={Util.setPhoneNum(telno)}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">생년월일</span>
                                <DatePickerBox
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    bgColor="#F6F6F6"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={brdtDate}
                                    disabled={true}
                                    onChange={() => {}}
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성별</span>
                                <SelectBox
                                    value={gndrCd}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getCodeArray("GNDR_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="dpFlx mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">
                                    발령일자 <span className="fcE60000">*</span>
                                </span>
                                <DatePickerBox
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="white"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={applyDt}
                                    onChange={(data: string) => setApplyDt(data)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 변경 내역 */}
                <div className="ml10 mr10 mt20">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">변경 내역</div>

                    <div className="bd1 bdcDDDDDD bdrd10">
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-b fs13 fc111111 bgcFAFAFA bdrdtl10">구분</div>
                            <div className="w195 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcFAFAFA">현재</div>
                            <div className="w195 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcF1F8FF">변경</div>
                            <div className="w50 h40 dpFlx aiC jcC fm-b fs12 fc111111 bdl1 bdcDDDDDD bgcFAFAFA bdrdtr10">상태</div>
                        </div>

                        {/* 본부 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-c fs14 fc333333">본부</div>
                            <div className="w195 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {Util.getUpOrgName(upOgnzCd)}
                                </div>
                            </div>
                            <div className="w195 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={chgUpOgnzCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getUpOrgCodeArray("01").slice(1)}
                                    placeholder="본부 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => {
                                        setChgUpOgnzCd(data);
                                        setChgOgdpOrgCd("");
                                    }}
                                />
                            </div>
                            <div className="w50 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(upOgnzCd, chgUpOgnzCd)}
                            </div>
                        </div>

                        {/* 지부 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-c fs14 fc333333">지부</div>
                            <div className="w195 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {Util.getDownOrgName(ogdpOrgCd)}
                                </div>
                            </div>
                            <div className="w195 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={chgOgdpOrgCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getDownOrgCodeArray(chgUpOgnzCd)}
                                    placeholder={Util.isEmpty(chgUpOgnzCd) ? "본부 먼저 선택" : "지부 선택"}
                                    paddingRight={8}
                                    disabled={Util.isEmpty(chgUpOgnzCd)}
                                    onChangeFunc={(data: string) => setChgOgdpOrgCd(data)}
                                />
                            </div>
                            <div className="w50 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(ogdpOrgCd, chgOgdpOrgCd)}
                            </div>
                        </div>

                        {/* 근로형태 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-c fs14 fc333333">근로형태</div>
                            <div className="w195 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {Util.getValToCode("LBR_SHP_SE_CD", lbrShpSeCd)}
                                </div>
                            </div>

                            <div className="w195 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={lbrShpSeCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getCodeArray("LBR_SHP_SE_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                            <div className="w50 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(lbrShpSeCd, lbrShpSeCd)}
                            </div>
                        </div>

                        {/* 직종 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-c fs14 fc333333">직종</div>
                            <div className="w195 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {Util.getValToCode("OCPT_TYPE_CD", ocptTypeCd)}
                                </div>
                            </div>
                            <div className="w195 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={chgOcptTypeCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray(lbrShpSeCd === "01" ? "PMEMP_OCPT_TYPE_CD" : "IREMP_OCPT_TYPE_CD")}
                                    placeholder="직종 선택"
                                    paddingRight={8}
                                    disabled={Util.isEmpty(lbrShpSeCd)}
                                    onChangeFunc={(data: string) => setChgOcptTypeCd(data)}
                                />
                            </div>
                            <div className="w50 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(ocptTypeCd, chgOcptTypeCd)}
                            </div>
                        </div>

                        {/* 관내 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w80 h40 dpFlx aiC jcC fm-c fs14 fc333333">관내</div>
                            <div className="w195 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {wtjrNm}
                                </div>
                            </div>
                            <div className="w195 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <TextBox
                                    value={chgWtjrNm}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                    placeholder="관내 입력"
                                    onChangeFunc={(text: string) => setChgWtjrNm(text)}
                                />
                            </div>
                            <div className="w50 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(wtjrNm, chgWtjrNm)}
                            </div>
                        </div>

                        {/* 주소 */}
                        <div className="dpFlx">
                            <div className="w80 h80 dpFlx aiC jcC fm-c fs14 fc333333">
                                주소
                            </div>

                            <div className="w390 bdl1 bdcDDDDDD">
                                <div className="h40 dpFlx aiC bdb1 bdcDDDDDD">
                                    <div className="pl15 fm-c fs13 fc333333">
                                        {addr}
                                    </div>
                                </div>

                                <div className="h40 dpFlx aiC pl15 bgcF1F8FF">
                                    <TextBox
                                        value={chgAddr}
                                        width={360}
                                        height={36}
                                        fontSize={13}
                                        fontFamily="fm-c"
                                        color="#333"
                                        letterSpacing={-1}
                                        borderColor="#ddd"
                                        borderOnColor="#222"
                                        borderRadius={5}
                                        style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                        placeholder="주소 변경 시 입력"
                                        onChangeFunc={(text: string) => setChgAddr(text)}
                                    />
                                </div>
                            </div>
                            <div className="w50 h80 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                {renderChangeStatus(addr, chgAddr)}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 반려 사유 */}
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">반려 사유</span>
                        </div>
                        <textarea
                            value={atrzOpnnCn}
                            className="w520 h60 bsBdb p10 bd1 bdcDFDFDF bdrd4 fm-c fs14 fc333333 ls1 rszN"
                            style={{ backgroundColor: "#f6f6f6" }}
                            maxLength={2000}
                            disabled={true}
                        />
                    </div>
                )}

                {/* 첨부파일 */}
                <div className="mt20 p14 bd1 bdcDDDDDD bdrd10 w520 bgcFAFAFA bsBdb ml10">
                    <div className="fm-c fs16 fc111111 mb10">첨부파일</div>

                    <div>
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">기타 첨부파일</span>
                            <span className="fm-c fs11 fc007bff ml4">(필수 아님)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                setMbrasAtchFileId={setEtcAtchFileId}
                                mbrFile={etcFile}
                                setMbrFile={setEtcFile}
                                mbrFileNm={etcFileNm}
                                setMbrFileNm={setEtcFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt10 taC">
                    <span className="fm-c fs12 fc4A90A4">
                        ※ 임시저장은 입력 중인 내용으로 저장되며, 작성완료는 필수 항목 입력 후 가능합니다.
                    </span>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb10">
                    {Util.isEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styCancelBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="이전"
                            onClickFunc={() => setModalStep("CHANGE_TYPE")}
                        />
                    )}

                    <Button
                        width={90}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => setModalOpen(false)}
                    />

                    {Util.isNotEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styDeleteBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="삭제"
                            onClickFunc={handleDelete}
                        />
                    )}

                    {atrzSttsCd === "01" && (
                        <Button
                            width={110}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styTempBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="임시저장"
                            onClickFunc={() => handleSave("01")}
                        />
                    )}

                    <Button
                        width={110}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCompleteBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="작성완료"
                        onClickFunc={() => handleSave("02")}
                    />
                </div>
            </div>
        </div>
    );
};

export default MbrasDepartApply;